/**
 * wx 接口
 */

const wx = window.wx || {};

export default wx;


/**
 * 检察当前场景值是否要显示回到首页按钮
 * @param {String} scene 场景值
 */
export function showBackHomeButton(scene) {
  return SCENE_LIST.indexOf(scene) !== -1;
}

/**
 * 判断当前环境是否为小程序环境
 */
export function isMiniProgramEnv() {
  const agent = window.navigator.userAgent;

  return window.isMiniProgram
    || agent.indexOf('miniProgram') >= 0 // 官方文档说明是这个
    || agent.indexOf('miniprogram') >= 0 // 实际浏览器包含的是这个
    || window.__wxjs_environment === 'miniprogram';
}

/**
 * 获取微信地址
 * @param {String} referer 获取地址后返回的地址
 */
export function getWxAddress(referer) {
  referer = encodeURIComponent(referer);
  window.wx.miniProgram.navigateTo({
    url: `/pages/api/address?referer=${referer}`
  });
}

/**
 * 去微信支付
 * @param {String} pay_sn 加密支付串
 * @param {String} failUrl 支付失败后跳转的地址
 * @param {String} referer 支付成功跳转URL
 * @param {String} awardToken 活动token
 */
export function gotoWxPayment(orderId, hash = '') {
  // oldParams: pay_sn, failUrl, referer, awardToken
  // failUrl = encodeURIComponent(failUrl);
  // referer = encodeURIComponent(referer);
  // 下单之后返回活动列表页面需要刷新
  // window.wx.miniProgram.postMessage({
  //   data: {
  //     from: 'activity-goods-book-success'
  //   }
  // });
  // window.wx.miniProgram.navigateTo({
  //   url: `/pages/api/pay?pay_sn=${pay_sn}&failUrl=${failUrl}&referer=${referer}&awardToken=${awardToken}`
  // });
  window.wx.miniProgram.navigateTo({
    url: `/pages/pay/index?orderid=${orderId}&hash=${hash}&channel=poi`
  });
}

// 下列场景值需要显示回到首页按钮
const SCENE_LIST = [
  '1007', // 单人会话的小程序消息卡片
  '1008', // 群聊会话的小程序消息卡片
  '1011', // 扫描二维码
  '1012', // 长按图片识别二维码
  '1013', // 扫描相册中二维码
  '1014', // 小程序模版消息
  '1035', // 公众号自定义菜单
  '1036', // App分享消息卡片
  '1037', // 小程序打开小程序
  '1038', // 从另一个小程序返回
  '1043', // 公众号模版消息
  '1044', // 带shareTicket的小程序消息卡片
  '1045', // 朋友圈广告
  '1046', // 朋友圈广告详情页
  '1047', // 扫描小程序码
  '1048', // 长按图片识别小程序码
  '1049', // 扫描相册中小程序码
  '1052', // 卡券的适用门店列表
  '1058', // 公众号文章
  '1067', // 公众号文章广告
  '1072', // 二维码收款页面
  '1073', // 客服消息列表下发的小程序消息卡片
  '1074', // 公众号会话下发的小程序消息卡片
  '1081', // 客服消息下发的文字链
  '1082', // 公众号会话下发的文字链
  '1084', // 朋友圈广告原生页
  '1089', // 我的小程序
  '1090', // 最近使用历史
  '1091', // 公众号文章商品卡片
  '1095', // 小程序广告组件
  '1096', // 聊天记录
  '1102', // 公众号profile页服务预览
  '1104' // 我的小程序
];
